export function redeemPromoCode(promoCodeData) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'promoCodes/redeemed',
                payload: promoCodeData
            });
            resolve(true)
        });
    }
};

export function resetPromoCodeData() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'promoCodes/reset'
            });
            resolve(true)
        });
    }
};